export default "__VITE_ASSET__D9i1qoN$__"